module.exports = __webpack_public_path__ + "themes/fq/sprite/queenhand.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/queenhand.json
// module id = 100
// module chunks = d-game